import { disableButtons } from './disableButtonsActions';

export const loginError = err => {
    return {
        type: 'LOGIN_ERROR',
        err
    }
};

export const userLogin = (user, pass, history) => {
    return dispatch => {
        dispatch(disableButtons(true));
        return fetch(`${process.env.REACT_APP_API_URL}/login/ipsad_panel`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify({
                username: user,
                password: pass
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                }
            })
            .then(res => {
                dispatch(disableButtons(false));
                return res.token
            })
            .then(token => {
                sessionStorage.setItem('ipsadToken', token);
                dispatch(disableButtons(false));
            })
            .then(() => sessionStorage.getItem('ipsadToken')
                ? history.push('/')
                : null
            )
            .catch(err => {
                dispatch(loginError('error'));
                dispatch(disableButtons(false));
            });
    }
};
